import { useQuery } from '@tanstack/react-query';

import { type PromoCampaignSearchParams, searchPromoCampaigns } from '~/services/LuxLoyalty';

import { promoCampaignQueryKeys } from './promoCampaignQueryKeys';

interface UseSearchPromoCampaignsOptions {
  enabled?: boolean;
}

export function useSearchPromoCampaigns(
  params: PromoCampaignSearchParams,
  options: UseSearchPromoCampaignsOptions = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: promoCampaignQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return await searchPromoCampaigns(params, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled,
    retry: false,
  });
}
